import { Pipe, PipeTransform } from '@angular/core';

import { Schema } from '@shared/models';

@Pipe({
  name: 'sortSchemas',
  standalone: true,
})
export class SortSchemasPipe implements PipeTransform {
  transform(schemas: Schema[], isTablet: boolean): Schema[] {
    const sortedSchemas = schemas.sort((a, b) => {
      if (!isTablet) {
        return a.mobileIndex - b.mobileIndex;
      } else {
        return a.desktopIndex - b.desktopIndex;
      }
    });

    return sortedSchemas;
  }
}
